// @flow

import {
  SEARCH_RECEIVED_PRODUCTS_SUCCESS,
  SEARCH_RECEIVED_PRODUCTS_FAILED,
  GET_RECEIVED_PRODUCT_SUCCESS,
  GET_RECEIVED_PRODUCT_FAILED,
} from '../constants'

import type { Coverage } from '../types'

const initialState = {
  coverages: [],
  error: '',
  totalResults: 0,
  coverage: null,
}

type State = {
  coverages: Array<Coverage>,
  error: string,
  totalResults: number,
  coverage: Coverage | null,
}

type Action = {
  type: string,
  payload: any,
}

function resellBeta(state: State = initialState, action: Action) {
  switch (action.type) {
    case SEARCH_RECEIVED_PRODUCTS_SUCCESS:
      return {
        ...state,
        coverages: action.payload.coverages,
        totalResults: action.payload.total
      }
    case SEARCH_RECEIVED_PRODUCTS_FAILED:
      return {
        ...state,
        error: action.payload,
        coverages: []
      }
    case GET_RECEIVED_PRODUCT_SUCCESS:
      return {
        ...state,
        coverage: action.payload
      }
    case GET_RECEIVED_PRODUCT_FAILED:
      return {
        ...state,
        error: action.payload
      }
    default:
      return state
  }
}

export default resellBeta



// WEBPACK FOOTER //
// ./src/modules/resellBeta.js